<template>
  <div class="grid-tile">
    <img alt="device thumb" class="grid-thumb" :src="getThumbUrl(scenario)" />
    <div class="grid-label">
      {{ scenario.name }}
      <span v-if="isPrivate" class="font-italic"> (private)</span>
    </div>
  </div>
</template>

<script>
import ScenarioHelper from "../utils/scenario.helper";

export default {
  props: {
    scenario: Object,
  },
  name: "ScenarioMiniTile",
  data() {
    return {
      PRIVACY_LEVELS: {
        PRIVATE: 0,
        ORGANISATION: 1,
        PUBLIC: 2,
      },
      isLoading: false,
    };
  },
  computed: {
    isPrivate() {
      return this.scenario.privacy_level === this.PRIVACY_LEVELS.PRIVATE;
    },
  },
  methods: {
    getThumbUrl(scenario) {
      if (scenario.object_url && scenario.object_url.includes(".ctgi")) {
        return require("../assets/device/CTGi.png");
      } else {
        return require("../assets/device/" +
          ScenarioHelper.getFilenameForDeviceThumb(scenario.device_id));
      }
    },
  },
};
</script>

<style scoped>
.grid-tile {
  border: 1px solid var(--isim-light-icon);
  border-radius: 4px;
  margin: 8px;
  position: relative;
  cursor: pointer;
  width: 182px; /* .grid-thumb + 2px for border */
}

.grid-thumb {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  width: 180px;
}

.grid-label {
  font-size: 12px;
  font-weight: 700;
  color: #014a8f;
  padding: 8px;
}
.grid-label i {
  color: var(--isim-primary);
}
</style>
